class invoiceCollectionDetailCtrl {
    constructor($scope, logger, httpRequest, $state, globalFn) {
        const invoice_info = JSON.parse($state.params.object)
        $scope.showlistflag = true
        $scope.showPdf = true
        $scope.collapse = function collapse() {
            $scope.showPdf = !$scope.showPdf
        }
        $scope.param = {}
        $scope.param.currentListPage = 1
        // 清单分页查询
        $scope.pageListChanged = function () {
            httpRequest.post_queryInvoiceDetail({
                pageNum: $scope.param.currentListPage,
                pageSize: 10,
                param: {
                    invoiceCode: invoice_info.invoiceCode,
                    invoiceNumber: invoice_info.invoiceNumber,
                    invoiceType: $scope.param.invoiceType,
                },
            }).then((responseData) => {
                $scope.param.detail = responseData.data.value.list
                $scope.param.totalListItems = responseData.data.value.total
            })
        }
        // 获取数据
        httpRequest.get_getInputInvoiceDetail(
            {
                invoiceCode: invoice_info.invoiceCode,
                invoiceNumber: invoice_info.invoiceNumber,
            },
        ).then((res) => {
            if (!res.data.value) {
                return logger.logError('暂无数据')
            }
            $scope.param = res.data.value
            httpRequest.post_queryInvoiceDetail({
                pageNum: 1,
                pageSize: 10,
                param: {
                    invoiceCode: invoice_info.invoiceCode,
                    invoiceNumber: invoice_info.invoiceNumber,
                    invoiceType: $scope.param.invoiceType,
                },
            }).then((responseData) => {
                $scope.param.detail = responseData.data.value.list
                $scope.param.totalListItems = responseData.data.value.total
            })
            httpRequest.get_getIvatFiles({
                invoiceCode: invoice_info.invoiceCode,
                invoiceNumber: invoice_info.invoiceNumber,
            }).then((response) => {
                $scope.param.fileInfoList = response.data.value
                if ($scope.param.fileInfoList && $scope.param.fileInfoList.length == 1) {
                    $scope.param.imageKey = host.etcloudPdf + $scope.param.fileInfoList[0].storageKey
                    if ($scope.param.fileInfoList[0].fileType === 'pdf') {
                        $scope.isPdf = true
                        const win = window.open($scope.param.imageKey)
                        win.onload = () => {
                            $(win.document.documentElement).prepend('<head><title>影像详情</title></head>')
                            const timer = setInterval(() => {
                                // 1
                                console.log($(win.document.documentElement).find('title'))
                                $(win.document.documentElement).find('title').empty()
                                $(win.document.documentElement).prepend('<head><title>影像详情</title></head>')
                            }, 100)
                            setTimeout(() => {
                                clearInterval(timer)
                            }, 10000)
                        }
                    } else {
                        $scope.isPdf = false
                    }
                } else {
                    $scope.param.imageKey = ''
                }
            })
            $scope.isTaxText = '不含税'
            // $scope.param.isTax = "0";
            // taxChange($scope.param.isTax);
            $scope.init()
            $scope.adValoremTotalChinese = globalFn.digitUppercase($scope.param.adValoremTotal)
            // 开票点数据
            if ($scope.ukeyList != null && $scope.ukeyList.length > 0) {
                for (let i = 0, l = $scope.ukeyList.length; i < l; i++) {
                    if ($scope.ukeyList[i].ukeyId === $scope.param.ukeyId) {
                        $scope.param.ukeyName = $scope.ukeyList[i].ukeyName
                    }
                }
            }
        })

        // 2 -- 系统初始化
        $scope.init = function () {
            if ($scope.param.isTax == '1') {
                $scope.isTaxText = '含税'
            }
        }
    }
}

invoiceCollectionDetailCtrl.$inject = ['$scope', 'logger', 'httpRequest', '$state', 'globalFn']
export default invoiceCollectionDetailCtrl



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/collection/invoiceCollectionDetailCtrl.js